/**
 * Whole dollars from what was typed: commas and "$" ignored, cents rounded to
 * the dollar. Used to keep only the digits, which turned "1500.50" into
 * $150,050 (2026-09-28). A minus sign is ignored and the result never goes
 * below 0 (Drew, 2026-09-29), except on the six lines v32 lets go negative —
 * capital gains, Schedule 1 other income and the K-1 lines — where
 * `allowNegative` keeps a leading minus, a "(20,000)" loss, or the Unicode
 * minus a PDF or Excel paste carries.
 */
export function parseDollars(text: string, allowNegative = false): number {
  const normalized = text.replace(/−/g, '-');
  const negative = allowNegative && (
    /^\s*\(.*\)\s*$/.test(normalized) || normalized.replace(/[^\d.-]/g, '').startsWith('-')
  );
  const n = parseFloat(normalized.replace(/[^\d.]/g, ''));
  if (!Number.isFinite(n)) return 0;
  const dollars = Math.round(n);
  return negative ? -dollars : dollars;
}
